import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconSecuritySvg } from "./IconSecuritySvg.mjs";
const IconSecurity = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconSecuritySvg, ...svgProps }) });
export {
  IconSecurity
};
